import { render } from "./D_memberFormList.vue?vue&type=template&id=5c8ebb81"
import script from "./D_memberFormList.vue?vue&type=script&lang=js"
export * from "./D_memberFormList.vue?vue&type=script&lang=js"

import "./D_memberFormList.vue?vue&type=style&index=0&id=5c8ebb81&lang=css"

import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__